import React from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import KpiCard from "../../components/KpiCard/KpiCard";
import Chart from "../../components/Chart/Chart";
import DataTable from "../../components/DataTable/DataTable";
import { Column } from "primereact/column";
import { Tag } from "../../components/Tag/Tag";

const Home: React.FC = () => {
  // Mock Data for KPI
  const kpiData = [
    { title: "Total FMEAs", value: 124, icon: "analytics", description: "+5 this week", trend: "up" as const },
    { title: "Average RPN", value: 45.2, icon: "trending_flat", description: "Stable", trend: "neutral" as const },
    { title: "Open Action Plans", value: 18, icon: "assignment_late", description: "-2 from last month", trend: "down" as const },
    { title: "Critical Failures", value: 3, icon: "warning", description: "+1 reported today", trend: "down" as const }, // "down" trend color (red) for a bad thing going up
  ];

  // Mock Data for Chart
  const chartData = {
    labels: ['Low (< 40)', 'Medium (40-100)', 'High (> 100)'],
    datasets: [
      {
        label: 'RPN Distribution',
        data: [85, 34, 5],
        backgroundColor: [
          '#10b981', // success
          '#f59e0b', // warning
          '#ef4444', // error
        ],
      }
    ]
  };

  // Mock Data for DataTable
  const tableData = [
    { id: 1, family: "Motor Family A", type: "Design", failures: 12, actionPlans: 3, maxRpn: 120 },
    { id: 2, family: "Chassis Series X", type: "Process", failures: 8, actionPlans: 1, maxRpn: 45 },
    { id: 3, family: "Brake System", type: "Process", failures: 24, actionPlans: 5, maxRpn: 85 },
    { id: 4, family: "Electrical Harness", type: "Design", failures: 5, actionPlans: 0, maxRpn: 25 },
  ];

  const getRpnSeverity = (rpn: number): "successInverse" | "warningInverse" | "errorInverse" => {
    if (rpn <= 39) return "successInverse";
    if (rpn <= 100) return "warningInverse";
    return "errorInverse";
  };

  return (
    <div className="overflow-hidden" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', paddingBottom: '1.5rem' }}>
      <PageHeader 
        title="FMEA Management Dashboard" 
        description="Monitor Failure Mode and Effect Analysis across products and families"
      />

      <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
        {kpiData.map((kpi, idx) => (
          <KpiCard
            key={idx}
            title={kpi.title}
            value={kpi.value}
            icon={kpi.icon}
            description={kpi.description}
            trend={kpi.trend}
          />
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: "1.5rem", alignItems: "start" }}>
        <Chart 
          title="RPN Distribution by Risk Level"
          type="bar" 
          data={chartData} 
        />
        
        <div style={{ backgroundColor: "var(--color-surface, #ffffff)", border: "1px solid var(--border-default, #e3e5e5)", borderRadius: "var(--border-radius-md, 8px)", padding: "1.5rem" }}>
          <h3 style={{ color: "var(--color-text-primary, #0f172a)", fontSize: "1rem", fontWeight: 600, margin: "0 0 1rem 0" }}>
            FMEA Overview
          </h3>
          <DataTable value={tableData}>
            <Column field="family" header="Family / Product" sortable />
            <Column field="type" header="Type" sortable />
            <Column field="failures" header="Failures" sortable />
            <Column field="actionPlans" header="Action Plans" sortable />
            <Column 
              field="maxRpn" 
              header="Max RPN" 
              sortable 
              body={(row) => (
                <Tag label={row.maxRpn.toString()} severity={getRpnSeverity(row.maxRpn)} />
              )}
            />
          </DataTable>
        </div>
      </div>
    </div>
  );
};

export default Home;
